import api, {create, deleteOne, getAll, getOne, RequestError, RequestResponse, update} from '../api';
import {QueryParams, Usuario} from '../../types';
const endpoint = 'users';
export default  {
    all: async (params?: QueryParams) => getAll<Usuario>({ endpoint, params }),
    one: async (id: string) => getOne<Usuario>({ endpoint, id }),
    destroy: async (id: string) => deleteOne({ endpoint, id }),
    create: async (formData: Partial<Usuario>) => create<Usuario>({ endpoint, formData }),
    update: async (id: string, formData: Partial<Usuario>) => update<Usuario>({ endpoint, formData, id }),
}